(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hypertune-modal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const modal = document.querySelector('dialog[data-hypertune-modal]');
  if (!modal) return;

  const patterns = (modal.dataset.triggerMatch || '')
    .split(',')
    .map((pattern) => pattern.trim().toLowerCase())
    .filter(Boolean);

  const openModal = () => {
    if (!modal.open) modal.showModal();
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!patterns.length) return;
      const link = event.target.closest('a[href]');
      if (!link || modal.contains(link)) return;
      const href = link.href.toLowerCase();
      if (patterns.some((pattern) => href.includes(pattern))) {
        event.preventDefault();
        event.stopPropagation();
        openModal();
      }
    },
    true
  );

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target.closest('[data-hypertune-close]')) {
      modal.close();
    }
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', (event) => {
      if (event.target.contains(modal)) openModal();
    });

    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.target.contains(modal)) modal.close();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
